import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';

import { useUserState, useUserStateDispatch } from 'contexts/auth-context';

import t from 'utils/translateFunc';
import trackingEvent from 'utils/trackingEvent';

import { TextField, BtnGreenBig } from 'components/common/Elements/Elements';
import ModalTestUser from 'components/common/Elements/StatusTestUser/parts/ModalTestUser/ModalTestUser';

import { getRequest, postRequest } from 'utils/requests';

// import { isValid } from './validation';
import { login } from 'contexts/actions/authActions';

import { deleteAllCookies } from 'utils/common';

import LogoText from 'assets/svg/logoPurple.svg';

import classes from './LoginPage.module.scss';

const LoginPage = ({ history }) => {
  // const language = useUserState().user.language;
  const language = 'uk';

  const { auth } = useUserState();
  const dispatch = useUserStateDispatch();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [wrongText, setWrongText] = useState({ login: '', password: '' });
  const [otherError, setOtherError] = useState(false);
  const [modeResetPass, setModeResetPass] = useState('login');
  const [useremail, setUseremail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [subscribe, setSubscribe] = useState(false);
  const [modalTestUser, setModalTestUser] = useState(false);

  useEffect(() => {
    if (auth.isAuthenticated) {
      history.push('/groups');
    }

    if (
      !otherError &&
      !auth.isAuthenticated &&
      auth.isLogin &&
      auth.error === '403'
    ) {
      deleteAllCookies();
      setOtherError(true);
      login({ username, password })(dispatch);
    } else {
      if (!auth.isAuthenticated && auth.isLogin && auth.error === '1002') {
        setWrongText({
          login: t('error', 'ERR_USERNAME', language),
          password: ''
        });
      } else if (
        !auth.isAuthenticated &&
        auth.isLogin &&
        auth.error === '1003'
      ) {
        setWrongText({
          login: '',
          password: t('error', 'HUB_AUTH_ERROR', language)
        });
      } else if (
        !auth.isAuthenticated &&
        auth.isLogin &&
        auth.error === '1004'
      ) {
        setWrongText({ login: '', password: t('error', 'ERR_PASS', language) });
      } else if (
        !auth.isAuthenticated &&
        auth.isLogin &&
        auth.error === '1005'
      ) {
        setWrongText({
          login: '',
          password: t('error', 'ALREADY_EXISTS', language)
        });
      } else if (
        !auth.isAuthenticated &&
        auth.isLogin &&
        auth.error === '1006'
      ) {
        setWrongText({
          login: ' ',
          password: t('error', 'ERR_TRIAL', language)
        });
        setSubscribe(true);
      } else if (!auth.isAuthenticated && auth.isLogin) {
        setWrongText({
          login: ' ',
          password: t('error', 'ERR_SERVER', language)
        });
      }
    }
    // eslint-disable-next-line
  }, [auth, history]);

  useEffect(() => {
    deleteAllCookies();
  }, []);

  const onSubmit = e => {
    trackingEvent('user_login');
    e.preventDefault();

    login({ username, password })(dispatch);
  };

  const onSubmitResetPass = e => {
    e.preventDefault();
    trackingEvent('send_link_pass');

    const url = `/api/accounts/password-reset-request`;

    const REQ_BODY = {
      email: useremail
    };

    postRequest(url, REQ_BODY)
      .then(() => {
        setUseremail('');
        setEmailError('');
        setModeResetPass('resend');
      })
      .catch(err => {
        setEmailError(t('error', 'ERR_REGISTRATION', language));
      });
  };

  const onUsername = e => {
    setUsername(e.target.value);
    if (subscribe) {
      setSubscribe(false);
    }
    if (wrongText !== { login: '', password: '' }) {
      setWrongText({ login: '', password: '' });
    }
  };

  const onPassword = e => {
    setPassword(e.target.value);
    if (subscribe) {
      setSubscribe(false);
    }
    if (wrongText !== { login: '', password: '' }) {
      setWrongText({ login: '', password: '' });
    }
  };

  const onUseremail = e => {
    setUseremail(e.target.value);
    if (emailError !== '') {
      setEmailError('');
    }
  };

  const isDisabledEmail = () => {
    return !useremail;
  };

  const onResetPass = () => {
    trackingEvent('forgot_pass');
    setModeResetPass(modeResetPass === 'login' ? 'reset' : 'login');
    setUseremail('');
    setEmailError('');
    const btnForgotPass = document.getElementById('idResetPass');
    btnForgotPass.blur();
  };

  const onSubscribe = () => {
    trackingEvent('trial_ok');
    getRequest(`/api/accounts/${username}/subscribe`)
      .then(() => {
        setModalTestUser(true);
      })
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <>
      <ModalTestUser
        isOpen={modalTestUser}
        setIsOpen={() => {
          setModalTestUser(false);
        }}
        activated={true}
      />
      <div className={classes.loginPage}>
        <div className={classes.infoBox}>
          <div className={classes.formWrap}>
            <h1 className={classes.title}>
              <p className={classes.title_top}>
                {t('LoginPage', 'SIGN_IN', language)}
              </p>
              <p className={classes.title_bottom}>
                {t('LoginPage', 'ACCOUNT', language)}
                <img
                  src={LogoText}
                  className={classes.logo}
                  alt="logo"
                  width="115"
                  height="20"
                />
              </p>
            </h1>
            {modeResetPass === 'login' && (
              <form onSubmit={onSubmit} className={classes.loginForm}>
                <div>
                  <TextField
                    className={
                      wrongText.login && wrongText.login === ' '
                        ? classes.emailField_errorServer
                        : wrongText.login
                        ? classes.emailField_error
                        : classes.emailField
                    }
                    borderRadius
                    value={username}
                    onChange={onUsername}
                    labelText={t('LoginPage', 'USERNAME', language)}
                    placeholder={t('LoginPage', 'USERNAME', language)}
                    required
                    errorText={wrongText.login}
                  />
                  <TextField
                    className={
                      wrongText.password
                        ? classes.passwordField_error
                        : classes.passwordField
                    }
                    borderRadius
                    value={password}
                    onChange={onPassword}
                    labelText={t('LoginPage', 'PASSWORD', language)}
                    placeholder={t('LoginPage', 'PASSWORD', language)}
                    type={'password'}
                    required
                    errorText={wrongText.password}
                  />
                </div>
                <BtnGreenBig
                  textButton={t('LoginPage', 'ENTER', language)}
                  type={'submit'}
                />
              </form>
            )}
            {modeResetPass === 'reset' && (
              <form onSubmit={onSubmitResetPass} className={classes.loginForm}>
                <div>
                  <TextField
                    className={
                      emailError
                        ? classes.useremailField_errorBig
                        : classes.useremailField
                    }
                    classNameLabelText={classes.textReset}
                    borderRadius
                    type="email"
                    value={useremail}
                    onChange={onUseremail}
                    labelText={t('LoginPage', 'RESET_TEXT', language)}
                    placeholder={t('LoginPage', 'ENTER_EMAIL', language)}
                    required
                    errorText={emailError}
                  />
                </div>
                <BtnGreenBig
                  textButton={t('LoginPage', 'SEND_LINK', language)}
                  type={'submit'}
                  disabled={isDisabledEmail()}
                />
              </form>
            )}
            {modeResetPass === 'resend' && (
              <form onSubmit={onSubmitResetPass} className={classes.loginForm}>
                <div>
                  <TextField
                    className={
                      emailError
                        ? classes.useremailField_errorBig
                        : classes.useremailField
                    }
                    classNameLabelText={classes.textReset}
                    borderRadius
                    type="email"
                    value={useremail}
                    onChange={onUseremail}
                    labelText={t('LoginPage', 'RESEND_TEXT', language)}
                    placeholder={t('LoginPage', 'ENTER_EMAIL', language)}
                    required
                    errorText={emailError}
                  />
                </div>
                <BtnGreenBig
                  textButton={t('LoginPage', 'RESEND_LINK', language)}
                  type={'submit'}
                  disabled={isDisabledEmail()}
                />
              </form>
            )}
            {subscribe && (
              <BtnGreenBig
                className={classes.subscribeBtn}
                textButton={t('LoginPage', 'SUBSCRIBE', language)}
                onClick={onSubscribe}
              />
            )}
            <button
              id="idResetPass"
              type="button"
              className={classes.linkForgot}
              onClick={onResetPass}
            >
              {modeResetPass === 'login'
                ? t('LoginPage', 'Q_FORGOT_PASS', language)
                : t('LoginPage', 'CANCEL_RESET_PASS', language)}
            </button>
          </div>
        </div>
        <Media
          queries={{
            large: '(min-width: 1280px)'
          }}
        >
          {matches => (
            <>{matches.large && <div className={classes.decorBox}></div>}</>
          )}
        </Media>
      </div>
    </>
  );
};

LoginPage.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired
};

export default LoginPage;
